export const promotionsRoutes = [
  {
    name: 'promotions',
    path: '/promotions',
    component: () => import('@/modules/promotions/views/Promotions.vue'),
    meta: {
      locationTypes: ['organization', 'singleLocation']
    }
  }
]
